import React from 'react';
import { useHistory } from 'react-router-dom';
import { Auth0Provider } from '@auth0/auth0-react';
import { SnackbarProvider } from 'notistack';

import 'src/stylesheets/rc-menu.scss';
import 'src/stylesheets/search.scss';
import routes, { renderRoutes } from 'src/routes';
import { auth0Config } from 'src/config';
import { UserProvider } from 'src/contexts/UserContext';
import { basename } from 'src/config';

function App() {
  const history = useHistory();

  const onRedirectCallback = (appState) => {
    history.push(
      appState && appState.returnTo
        ? appState.returnTo.replace(basename, '')
        : `${window.location.origin}`
    );
  };

  /**
   * ingressが /bois/* でのアクセスを期待するため、redirectUriにトレイリングスラッシュを入れること
   * トレイリングスラッシュがない場合、Auth0からのコールバック時に無限ループが発生する
   */
  return (
    <Auth0Provider
      {...auth0Config}
      redirectUri={`${window.location.origin}${basename}/`}
      onRedirectCallback={onRedirectCallback}
    >
      <SnackbarProvider dense maxSnack={3}>
        <UserProvider>{renderRoutes(routes)}</UserProvider>
      </SnackbarProvider>
    </Auth0Provider>
  );
}

export default App;
